import { Link } from "react-router-dom";
import AccountDashboard from "../components/Account/AccountDashboard";
import SignInForm from "../components/Account/SignInForm";
import { useAuth } from "../auth/AuthContext";
import "./Account.css";

export default function Account() {
  const { user, signIn, signOut } = useAuth();

  return (
    <>
      <div className="account-route">
        <div className="account-back-bar">
          <Link to="/" className="account-back">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              width="18"
              height="18"
            >
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
            Back to home
          </Link>
        </div>

        {user ? (
          <AccountDashboard user={user} onSignOut={signOut} />
        ) : (
          <SignInForm onSignIn={signIn} />
        )}
      </div>
    </>
  );
}
